const getters = {
    permissions:(state)=> state.app.permissionList,
    roles:(state)=> state.app.roles,
  }
  export default getters